(ns machtfit.widgets.button
  (:require
   [machtfit.widgets.icon :as icon]))

(defn css-classes [color size dropdown? full-width?]
  (into
   [(case size
      :2xl "h-14 px-5 py-3 gap-2.5 text-xl leading-loose"
      :xl "h-12 px-4 py-2.5 gap-1.5 text-lg leading-7"
      :lg "h-11 px-4 py-2 gap-1.5 text-base leading-normal"
      :md "h-10 px-3.5 py-2 gap-1 text-base leading-normal"
      :sm "h-8 px-3 py-1 gap-1 text-base leading-normal")

    (if (or dropdown? full-width?)
      "w-full"
      "w-fit")

    "text-nowrap"
    (when-not dropdown?
      "font-bold")

    "rounded-full"
    "border"

    (if dropdown?
      "justify-between"
      "justify-center")
    "items-center"
    "inline-flex"

    (when-not (= color :transparent-brand)
      "focus:ring-4")]
   (case color
     :secondary-color
     ["bg-white"
      (when-not dropdown?
        "hover:bg-brand-50")

      "border-brand-300"
      "disabled:border-brand-100"

      "text-brand-500"
      "hover:text-brand-850"
      "disabled:text-brand-300"

      "ring-brand-500/15"

      (when dropdown?
        "focus:border-brand-500 focus:ring-brand-500/[.24]")]

     :secondary-gray
     ["bg-white"
      (when-not dropdown?
        "hover:bg-gray-50")

      "border-gray-300"
      "disabled:border-gray-100"

      "text-gray-800"
      "hover:text-gray-850"
      "disabled:text-gray-500"

      "ring-gray-500/15"

      (when dropdown?
        "focus:border-brand-500 focus:ring-brand-500/[.24]")]

     :tertiary-gray
     ["bg-white"
      (when-not dropdown?
        "hover:bg-gray-50")

      "border-none"

      "text-gray-800"
      "hover:text-gray-850"
      "disabled:text-gray-500"

      "ring-gray-500/15"

      (when dropdown?
        "focus:border-brand-500 focus:ring-brand-500/[.24]")]

     :primary
     ["bg-brand-500"
      "hover:bg-brand-600"
      "disabled:bg-gray-50"

      "border-brand-500"
      "hover:border-brand-600"
      "disabled:border-gray-200"

      "text-white"
      "disabled:text-gray-500"

      "focus:ring-brand-500/[.24]"]

     :destructive-primary
     ["bg-error-500"
      "hover:bg-error-600"
      "disabled:bg-gray-50"

      "border-error-500"
      "hover:border-error-600"
      "disabled:border-gray-200"

      "text-white"
      "disabled:text-gray-500"

      "focus:ring-error-500/[.24]"]

     :transparent-brand
     ["bg-transparent"
      (when-not dropdown?
        "hover:bg-transparent")

      "border-transparent"
      "hover:border-transparent"
      "disabled:border-transparent"

      "text-brand-500"
      "hover:text-brand-600"
      "disabled:text-brand-300"])))

(defn button [{:keys [text
                      hierarchy
                      size
                      icon-leading
                      icon-trailing
                      disabled?
                      attrs
                      dropdown?
                      full-width?
                      focusable?
                      classes]
               :or {hierarchy :primary
                    size :lg
                    dropdown? false
                    full-width? false
                    focusable? true}}]
  (let [icon-width (if (= size :2xl) "w-6" "w-5")
        icon-height (if (= size :2xl) "h-6" "h-5")
        attrs (cond-> attrs
                disabled? (dissoc :href :on-click))
        element-type (if (:href attrs) :a :button)]
    [element-type (merge
                   attrs
                   {:disabled disabled?
                    :tab-index (when-not focusable? "-1")
                    :class (cond-> (css-classes hierarchy size dropdown? full-width?)
                             classes (conj classes))})
     (when icon-leading
       [icon/outline icon-leading {:width icon-width
                                   :height icon-height}])

     text
     (when icon-trailing
       [icon/outline icon-trailing {:width icon-width
                                    :height icon-height}])]))
